import RestClient from '../../../lib/RestClient';
import * as React from "react";
import {NavLink} from "react-router-dom";
import {formatCurrency} from "../utils/numbers";

//the base url of the rest endpoint
const URL = 'auction/';

export interface IDataStructureInformation {
    languageTag: string,
    sortingSelectorTag: string,
    srcVariableName: string,
    renderFunction: Function | null;
}

class AuctionService {

    public dataStructureInformations: IDataStructureInformation[] = [
        {
            languageTag: "Auctions.Article",
            sortingSelectorTag: "data.sorteNr2",
            srcVariableName: "sorteNr2",
            renderFunction: null
        },
        {
            languageTag: "Auctions.Length",
            sortingSelectorTag: "data.laenge",
            srcVariableName: "laenge",
            renderFunction: null
        },
        {
            languageTag: "Auctions.Description",
            sortingSelectorTag: "data.beschreibung",
            srcVariableName: "beschreibung",
            renderFunction: (dataRow: any): React.ReactNode => {
                const returnValue = React.createElement(
                    NavLink,
                    {to: ("/auctions/" + dataRow.data.sorteNr2 + "/" + dataRow.data.laenge)},
                    ("\xa0" + dataRow.data.beschreibung)
                );
                return returnValue;
            }
        },
        {
            languageTag: "Auctions.Count",
            sortingSelectorTag: "data.gesamtAnzahl",
            srcVariableName: "gesamtAnzahl",
            renderFunction: null
        },
        {
            languageTag: "Auctions.PriceLow",
            sortingSelectorTag: "data.preisNiedrig",
            srcVariableName: "preisNiedrig",
            renderFunction: (dataRow: any): React.ReactNode => {
                return (formatCurrency(dataRow.data.preisNiedrig));
            }
        },
        {
            languageTag: "Auctions.PriceAverage",
            sortingSelectorTag: "data.preisDurchschnitt",
            srcVariableName: "preisDurchschnitt",
            renderFunction: (dataRow: any): React.ReactNode => {
                return (formatCurrency(dataRow.data.preisNiedrig));
            }
        },
        {
            languageTag: "Auctions.PriceMax",
            sortingSelectorTag: "data.preisHoechst",
            srcVariableName: "preisHoechst",
            renderFunction: (dataRow: any): React.ReactNode => {
                return (formatCurrency(dataRow.data.preisNiedrig));
            }


        }

    ];

    public getAllData(filterObject: any, sortColumn: string, sortOrder: string,
                      pageToLoad: number, count: number) {
        const type = filterObject.type;
        let date = filterObject.selectedDate;
        const filter = filterObject.filter;

        if (date != null) {

            if (typeof date == "string")
                date = new Date(date);

            const year = date.getFullYear();
            const month = (date.getMonth() + 1 >= 10) ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
            const day = (date.getDate() >= 10) ? date.getDate() : "0" + (date.getDate());
            const dateString = year + "-" + month + "-" + day;

            return RestClient.get(URL, {
                type: type,
                date: dateString,
                filter: filter,
                sortBy: sortColumn,
                sortDirection: sortOrder,
                page: pageToLoad,
                count: count
            });
        } else {
            return RestClient.get(URL, {
                type: type,
                date: "",
                filter: filter,
                sortBy: sortColumn,
                sortDirection: sortOrder,
                page: pageToLoad,
                count: count
            });
        }
    }

    public getAllDates() {
        return RestClient.get(URL + "dates/", {});
    }

    public getAllByArcticle(articleID: String, articleLength: String, filter:  String, sortColumn: String, sortOrder: String, pageToLoad: number, count: number) {
        return RestClient.get(URL + articleID + "/" + articleLength, {
            filter: filter,
            sortBy: sortColumn,
            sortDirection: sortOrder,
            page: pageToLoad,
            count: count
        })
    }

}

const AuctionServiceInstance = new AuctionService();

export default AuctionServiceInstance;
